import { createContext } from 'react';

import type { AiSocket } from '../api/ai-socket';

export const AiSocketContext = createContext<AiSocket | null>(null);
